module.exports = __webpack_public_path__ + "img/logo-used-design.ca31227a.png";